Implantation = {
	
	map : false

	init: ->
		console.log 'Implantation init'

		@gmapManager()
		@regionsManager()

	regionsManager : ->
		
		_this = @

		mapSvg = $('.filters--map svg')
		regionId = $('.filters--name li.selected').attr('data-region')
		TweenLite.to(mapSvg.find('#'+regionId), 0.3, {fill: '#3E79ED'})

		$('.filters--name li').on "mouseenter", (ev) ->
			# Retrieve region Id
			regionId = $(@).attr('data-region')
			# Reset other regions bck color
			$.each mapSvg.find('path, polygon').not('#'+regionId), (i, elt) ->
				TweenLite.to(elt, 0.3, {fill: $(elt).attr('fill-save')})			

			# Change selected region bck color
			TweenLite.to(mapSvg.find('#'+regionId), 0.3, {fill: '#3E79ED'})

		$('.filters--name li').on 'mouseleave', (ev) ->
			regionId = $('.filters--name li.selected').attr('data-region')
			# Update map
			$.each mapSvg.find('path, polygon').not('#'+regionId), (i, elt) ->
				TweenLite.to(elt, 0.3, {fill: $(elt).attr('fill-save')})			
			# Change selected region bck color
			TweenLite.to(mapSvg.find('#'+regionId), 0.3, {fill: '#3E79ED'})

		$('.filters--name li').on 'click', (ev) ->
			if not $(@).hasClass 'selected'
				# Retrieve region Id
				regionId = $(@).attr('data-region')
				# Switch selected
				$('.filters--name li').removeClass 'selected'
				$(@).addClass 'selected'
				# Show region data
				_this.showRegion(regionId)

		$.each mapSvg.find('path.has-agences, polygon.has-agences'), (i, elt) ->
			$(elt).on 'mouseenter', (ev) ->
				$(elt).css('cursor', 'pointer')
				# Update map
				$.each mapSvg.find('path, polygon').not(elt), (i, elt) ->
					TweenLite.to(elt, 0.3, {fill: $(elt).attr('fill-save')})			
				# Change selected region bck color
				TweenLite.to(elt, 0.3, {fill: '#3E79ED'})
				# Update filters txt
				$('.filters--name li[data-region=' + $(@).attr('id') + ']').addClass 'hovered'

			$(elt).on 'mouseleave', (ev) ->
				regionId = $('.filters--name li.selected').attr('data-region')
				$('.filters--name li').removeClass('hovered')
				# Update map
				$.each mapSvg.find('path, polygon').not('#'+regionId), (i, elt) ->
					TweenLite.to(elt, 0.3, {fill: $(elt).attr('fill-save')})			
				# Change selected region bck color
				TweenLite.to(mapSvg.find('#'+regionId), 0.3, {fill: '#3E79ED'})

			$(elt).on "click", (ev) ->
				filterElt = $('.filters--name li[data-region=' + $(@).attr('id') + ']')
				if not filterElt.hasClass 'selected'
					regionId = filterElt.attr('data-region')
					# Switch selected
					$('.filters--name li').removeClass 'selected'
					filterElt.addClass 'selected'
					# Show region data
					_this.showRegion(regionId)


	showRegion : (region) ->

		_this = @

		# Retrieve region data
		regionDataElt = $('.implantation--data').find('[data-region=' + region + ']')
		
		addressesArr = []
		regionDataElt.find('[data-address]').each ->
			addressesArr.push {
				address : $(@).find('.address--block').clone() 
				marker : {
					lat : $(@).find('[data-marker]').attr('data-lat')
					long : $(@).find('[data-marker]').attr('data-long')
				}
			}

		regionData = {
			name : regionDataElt.find('[data-name]').html()
			addresses : addressesArr
		}

		# Show region data
		tlShowRegionData = new TimelineLite
		tlShowRegionData.addLabel 'start'
			.to window, 0.8, {scrollTo: { y: $('.implantation--addresses').offset().top, offsetY:100}, ease:Quint.easeInOut}
			.staggerTo [$('.implantation--addresses > h1 > span'), $('.implantation--addresses .txt-container')], 0.4, {x:20, autoAlpha:0, ease:Quint.easeOut}, 0.1
			.add -> 
				# Switch region label
				$('.implantation--addresses > h1 > span').html(regionData.name)
				
				# delete marker
				for i in [0.._this.map.markers.length-1]
					console.log _this.map.markers.length
					_this.map.markers[i].setMap(null)
				
				_this.map.markers = []
				bounds = new google.maps.LatLngBounds();
				
				# Switch addresses list 
				$('.implantation--addresses .txt-container').html('')
				
				$.each regionData.addresses, (i, elt) ->
					# append block
					$('.implantation--addresses .txt-container').append(elt.address)
					# Add marker
					latlng = new google.maps.LatLng( elt.marker.lat, elt.marker.long );
					bounds.extend(latlng)
					marker = new google.maps.Marker({
						position	: latlng,
						icon		: base_url + '/img/ico-pin.svg',
						map			: _this.map
					})
					_this.map.markers.push( marker )

				# Map auto center
				_this.map.fitBounds(bounds)

			.set [$('.implantation--addresses > h1 > span'), $('.implantation--addresses .txt-container')], {x:-20, autoAlpha:0}
			.staggerTo [$('.implantation--addresses > h1 > span'), $('.implantation--addresses .txt-container')], 0.4, {x:0, autoAlpha:1, ease:Quint.easeOut}, 0.1



	gmapManager : ->

		_this = @

		mapElt = $('#gmap') 
		markers = mapElt.find('.marker')
		
		args = {
			maxZoom		: 15,
			# center		: new google.maps.LatLng(45.223323, 2.888888),
			mapTypeId	: google.maps.MapTypeId.ROADMAP,
			fullscreenControl: false,
			mapTypeControl: false
			styles: 
				[
					{
						"featureType": "landscape",
						"elementType": "labels",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"featureType": "transit",
						"elementType": "labels",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"featureType": "poi",
						"elementType": "labels",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"featureType": "water",
						"elementType": "labels",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "labels.icon",
						"stylers": [
							{
								"visibility": "off"
							}
						]
					},
					{
						"stylers": [
							{
								"hue": "#00aaff"
							},
							{
								"saturation": -100
							},
							{
								"gamma": 2.15
							},
							{
								"lightness": 12
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "labels.text.fill",
						"stylers": [
							{
								"visibility": "on"
							},
							{
								"lightness": 24
							}
						]
					},
					{
						"featureType": "road",
						"elementType": "geometry",
						"stylers": [
							{
								"lightness": 57
							}
						]
					}
				]
		}
		
		# init gmap
		@map = new google.maps.Map( mapElt[0], args);
		
		# init bounds object
		bounds = new google.maps.LatLngBounds();
		
		# add marker
		@map.markers = [];
		markers.each ->
			latlng = new google.maps.LatLng( $(@).attr('data-lat'), $(@).attr('data-long') );
			bounds.extend(latlng)
			marker = new google.maps.Marker({
				position	: latlng,
				icon		: base_url + '/img/ico-pin.svg',
				map			: _this.map
			})
			_this.map.markers.push( marker )

		@map.fitBounds(bounds)


	destroy: ->
		console.log 'Implantation destroy'
}